import { TABLE_STORAGE_KEY } from 'ducks/table/table.constants';
import type { MappedTableState } from 'ducks/table/tableSlice';

import { LOGGER_TYPE } from 'api/types';
import { logToDataDog } from 'lib/ddlogHelper';

export const saveTableState = (state: MappedTableState) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(TABLE_STORAGE_KEY, serializedState);
  } catch (error) {
    // Ignore, but log to DD
    logToDataDog(
      LOGGER_TYPE.REDUX_STORAGE,
      'error',
      'Could not store table state in local storage',
      { error },
    );
  }
};
